import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useMemo, useState} from 'react';
import {Platform, View} from 'react-native';
import {connect} from 'react-redux';
import {WARNING} from '../../../../data/constants/warning';
import {ApiResponse} from '../../../../data/types/interface/api';
import {
  IDataWs,
  IDisplay,
} from '../../../../data/types/interface/demandeSimulation';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Label from '../../../components/Label';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {ProduitItem} from '../../../components/ProduitItem';
import globalStyle from '../../../styles/globalStyle';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<
  StackParams,
  'DemanderDevisAssuranceVoyage'
>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function FamilleSimulationScreen(props: any) {
  const {getTypeassurance} = props;
  const categorieId = props?.route?.params?.id;
  const [information, setInformation] = React.useState<{
    status: boolean;
    accept: boolean;
    message: string;
    type: string;
  }>({status: false, accept: false, message: '', type: ''});
  const {navigate} = useNavigation<NavigationProps>();

  const [listItem, setListItem] = useState<Array<IDataWs>>();
  useEffect(() => {
    getTypeassurance(
      {},
      (res: ApiResponse) => {
        setListItem([...res?.data?.items]);
      },
      `?categorieId=${categorieId}`,
    );
  }, [getTypeassurance]);

  const datas = useMemo(
    () =>
      listItem
        ? listItem.map(item => {
            let destinationPage = undefined;
            let action = () => {};
            let headerTitle = 'Demander simulation';

            if (item.nom.trim().toLowerCase() === 'assurance scolaire') {
              destinationPage = 'AssuranceScolaire';
              headerTitle = 'Demander simulation Scolaire';
            } else if (
              item.nom.trim().toLowerCase() === 'assurance rc vie privée'
            ) {
              destinationPage = 'AssuranceScolaire';
              headerTitle = 'Demander simulation RC Vie Privée';
            } else if (item.nom.trim().toLowerCase() === 'assurance voyage') {
              action = () =>
                setInformation({
                  accept: false,
                  status: true,
                  message: WARNING.voyage,
                  type: 'voyage',
                });
            } else if (
              item.nom
                .trim()
                .toLowerCase()
                .includes('assurance obsèques à dago')
            ) {
              action = () =>
                setInformation({
                  accept: false,
                  status: true,
                  message: WARNING.rapatriement,
                  type: 'rapatriement',
                });
            }
            return {
              libelle: item.nom,
              id: item.id,
              imageUrl: item.imageUrl ?? '',
              destinationPage,
              action,
              data: categorieId,
              headerTitle,
            };
          })
        : [],
    [listItem],
  );

  const display: IDisplay = {items: datas};

  const containerStyle =
    Platform.OS === 'web' ? globalStyle.containerFluid : styles.ListContainer;

  const changeStateData = () => {
    // information.accept && flowSouscriptionVoyage('true', (res: any) => {});
    const type = information.type;
    setInformation(prev => ({
      ...prev,
      accept: true,
      status: false,
      message: '',
    }));
    if (type == 'voyage') {
      navigate('DemanderDevisAssuranceVoyage', {
        category: '',
        destination: '',
        listNaissance: [],
        dateDebut: '',
        dateFin: '',
        motif: '',
      });
    } else if (type == 'rapatriement') {
      navigate('DemanderDevisAssuranceRapatriement');
    }
  };

  return (
    <View style={{flex: 1}}>
      {information.status && (
        <ConfirmationModal
          title="Information"
          content={information.message}
          btn1="OK"
          handleBtn1={changeStateData}></ConfirmationModal>
      )}
      <HeaderScreen
        title={props?.route?.params?.headerTitle}
        type="retour"
        noBreadcrumb={false}
      />
      <View style={containerStyle}>
        <View style={styles.ListLibelle}>
          <Label title="FAMILLE" type="mainTitle" />
        </View>
        {display.items.length <= 0 ? (
          <Loader />
        ) : (
          <ProduitItem data={display} />
        )}
      </View>
    </View>
  );
}
export const DemanderSimulationFamille = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FamilleSimulationScreen);

export default DemanderSimulationFamille;
